module.exports = __webpack_public_path__ + "static/media/icon_Journal_W.fe4aacae.svg";